import React from 'react';
import { IconProps } from 'types';

const PhoneIcon = ({ color, className }: IconProps) => {
  return (
    <svg
      className={className}
      height="20"
      width="20"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={`${color ? color : '#fff'}`}
        d="M 29.183594 22.015625 L 24.996094 17.832031 C 23.5 16.335938 20.960938 16.933594 20.363281 18.878906 C 19.914062 20.222656 18.417969 20.96875 17.074219 20.671875 C 14.082031 19.921875 10.042969 16.035156 9.296875 12.894531 C 8.847656 11.550781 9.746094 10.054688 11.089844 9.605469 C 13.035156 9.007812 13.632812 6.464844 12.136719 4.972656 L 7.953125 0.785156 C 6.753906 -0.261719 4.960938 -0.261719 3.914062 0.785156 L 1.074219 3.625 C -1.765625 6.617188 1.371094 14.539062 8.398438 21.570312 C 15.425781 28.597656 23.351562 31.886719 26.34375 28.894531 L 29.183594 26.054688 C 30.230469 24.859375 30.230469 23.0625 29.183594 22.015625 Z M 29.183594 22.015625 "
      />
    </svg>
  );
};

export default PhoneIcon;
